import TrainIcon from '@mui/icons-material/Train';

const StationIcon = (props) => {
    const {...other} = props;
    return (
        <TrainIcon {...other}/>
    )
}

export default StationIcon;